var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockerLIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 233,
    viewBox: "0 0 183 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.50001 73.4239L0.5 182.844C0.5 188.401 3.475 193.533 8.29741 196.295L65.7805 229.213C70.5058 231.919 76.3045 231.947 81.0557 229.286L174.573 176.924C179.468 174.182 182.5 169.01 182.5 163.399L182.5 51.8643C182.5 46.3815 179.603 41.3066 174.883 38.5183L116.647 4.12268C111.74 1.2245 105.638 1.25275 100.759 4.19628L7.99416 60.1515C3.34316 62.9569 0.500011 67.9923 0.50001 73.4239Z",
    fill: "#9035AF",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.898 8V127.176M107.898 127.176L6 186M107.898 127.176L178 166.519",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeDasharray: "15 15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1947 228V106.206M73.1947 106.206L4 68.4746M73.1947 106.206L179 47",
    stroke: "white",
    strokeDasharray: "15 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerLIcon);
export default __webpack_public_path__ + "static/media/locker_l_icon.858de6f789d9c98528300219dc97d5f4.svg";
export { ForwardRef as ReactComponent };